import { createReducer, createActions } from 'reduxsauce';
import update from 'immutability-helper';
import type { TransitTimes } from 'contracts/TransitTimes';

const { Types, Creators } = createActions(
  {
    request: ['id', 'onSuccess', 'onFailure'],
    success: ['data'],
    failure: ['errorMessage'],
    softReset: [],
    reset: [],
  },
  {
    prefix: 'FETCH_TRANSITTIME_',
  }
);

export interface FetchTransitTimeState {
  data: TransitTimes | null;
  loading: boolean;
  errorMessage: string | null;
}

export interface FetchTransitTimeRequestAction {
  id: number;
  onSuccess?: () => void;
  onFailure?: () => void;
}

interface SuccessAction {
  data: TransitTimes;
}

interface FailureAction {
  errorMessage: string;
}

const INITIAL_STATE: FetchTransitTimeState = {
  data: null,
  loading: false,
  errorMessage: null,
};

const request = (state: FetchTransitTimeState) =>
  update(state, {
    loading: { $set: true },
    errorMessage: { $set: null },
  });

const success = (state: FetchTransitTimeState, action: SuccessAction) =>
  update(state, {
    loading: { $set: false },
    data: { $set: action.data },
  });

const failure = (state: FetchTransitTimeState, action: FailureAction) =>
  update(state, {
    loading: { $set: false },
    errorMessage: { $set: action.errorMessage },
  });

const softReset = (state: FetchTransitTimeState) =>
  update(state, {
    loading: { $set: false },
  });

const reset = () => INITIAL_STATE;

export const fetchTransitTime = createReducer(INITIAL_STATE, {
  [Types.REQUEST]: request,
  [Types.SUCCESS]: success,
  [Types.FAILURE]: failure,
  [Types.SOFT_RESET]: softReset,
  [Types.RESET]: reset,
});

export const FetchTransitTimeTypes = Types;
export const FetchTransitTimeActions = Creators;
